<template>
  <b-container ref="successLinkContainer" id="success-link-container">
    <div class="success-link-container">
      <div class="success-card text-center">
        <div class="icon-container">
          <img
            class="icon"
            :src="require(`@/assets/images/icons/valid-payment-link.svg`)"
            alt="Invalid Link Icon"
          />
        </div>

        <h2 class="title">{{ t.validLink }}</h2>

        <p v-if="allSuccess" class="description">
          {{ t.validLinkDescription }}
        </p>

        <p v-else class="description">
          {{ t.validLinkDescriptionWithErrors }}
        </p>

        <template v-if="messages.length > 0">
          <div class="transaction-list">
            <div
              v-for="(message, index) in messages"
              :key="index"
              class="message-card py-1 px-05 mb-1 rounded-lg"
              :class="index === 0 ? 'mt-1' : ''"
            >
              <!-- Información resumida de la transacción -->
              <div class="message-info">
                <div class="" :class="isMobile ? 'text-left' : ''">
                  <feather-icon
                    v-if="message.status === 'success' && !isMobile"
                    :icon="
                      message.status === 'success'
                        ? 'CheckCircleIcon'
                        : 'XCircleIcon'
                    "
                    size="20"
                    class="mr-05"
                    :class="
                      message.status === 'success'
                        ? 'text-success'
                        : 'text-danger'
                    "
                  />

                  <b-img
                    class="client-program mr-05"
                    :src="getProgramImageRoute(message.program_id)"
                    v-b-tooltip.hover.top
                    :title="message.program"
                  />

                  <span class="text"
                    >{{ message.concept }} - {{ message.program }}
                  </span>
                </div>
                <!-- mr-1 -->
                <div :class="isMobile ? 'text-right' : ''">
                  <span class="text">{{
                    formatCurrency(message.transaction.settleAmount)
                  }}</span>
                  <!--                   
                  <feather-icon
                    class="cursor-pointer text"
                    icon="ChevronDownIcon"
                    size="20"
                    @click="toggleDetails(index)"
                  /> -->
                </div>
              </div>

              <!-- Detalle de la transacción -->
              <transition name="fade">
                <!-- v-if="expandedIndex === index" -->
                <div class="transaction-details mt-2">
                  <div class="message-row">
                    <span class="text text-left">{{ t.transactionId }}:</span>
                    <span class="text text-right">{{
                      message.transaction.transId
                    }}</span>
                  </div>
                  <div class="message-row">
                    <span class="text text-left">{{ t.card }}:</span>
                    <span class="text text-right">{{
                      message.card
                    }}</span>
                  </div>
                  <div class="message-row">
                    <span class="text text-left">{{ t.datetime }}:</span>
                    <span class="text text-right">{{
                      formatAmericanDateTime(message.transaction.submitTimeUTC)
                    }}</span>
                  </div>
                  <div class="message-row">
                    <span class="text text-left">{{ t.concept }}:</span>
                    <span class="text text-right">{{ message.concept }}</span>
                  </div>
                  <div class="message-row">
                    <span class="text text-left">{{ t.amount }}:</span>
                    <span class="text text-right">{{
                      formatCurrency(message.transaction.settleAmount)
                    }}</span>
                  </div>
                  <div class="message-row">
                    <span class="text text-left">{{ t.status }}:</span>
                    <span class="text d-flex align-items-center text-right">
                      <feather-icon
                        v-if="message.status === 'success'"
                        icon="CheckCircleIcon"
                        size="20"
                        class="text-success me-1"
                      />
                      <span
                        v-if="message.status !== 'success'"
                        class="text-danger"
                      >
                        <template
                          v-if="
                            message.message ===
                            'This transaction has been declined.'
                          "
                        >
                          {{ t.transactionDeclined }}
                        </template>
                        <template v-else>
                          {{ message.message }}
                        </template>
                      </span>
                    </span>
                  </div>
                  <div
                    v-if="
                      getPaymentDetail(message.program_id)
                        .is_automatic_payment && message.status === 'success'
                    "
                    class="message-row"
                  >
                    <span class="text text-left"
                      >{{ t.scheduledPaymentDate }}:</span
                    >
                    <span class="text text-right">
                      {{
                        getPaymentDetail(message.program_id)
                          .automatic_payment_date_text
                      }}</span
                    >
                  </div>
                  <div
                    v-if="
                      getPaymentDetail(message.program_id)
                        .is_automatic_payment && message.status === 'success'
                    "
                    class="message-row"
                  >
                    <span class="text text-left"
                      >{{ t.monthlyPaymentAmount }}:</span
                    >
                    <span class="text text-right">
                      {{
                        formatCurrency(
                          getPaymentDetail(message.program_id)
                            .automatic_payment_amount
                        )
                      }}</span
                    >
                  </div>
                </div>
              </transition>
            </div>
            <div
              class="d-flex flex-column flex-md-row justify-content-center align-items-center px-3 py-2"
            >
              <b-button
                class="text-uppercase mb-2 mb-md-0 mr-md-1 w-100 w-md-auto"
                variant="outline-primary"
                @click="generatePDF"
                style="max-width: max-content"
              >
                <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                {{ t.save }}
              </b-button>
              <b-button
                class="text-uppercase w-100 w-md-auto"
                variant="outline-danger"
                @click="close"
                style="max-width: max-content"
              >
                <feather-icon icon="XIcon" size="14" class="mr-1" />
                {{ t.close }}
              </b-button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div ref="pdfContainer" class="hidden">
      <PdfContent
        ref="pdfComponent"
        :messages="messages"
        :paymmentLinks="paymmentLinks"
        :t="t"
      />
    </div>
  </b-container>
</template>
<script>
import translations from "@/views/pages/secure-payment-form/data/translations.js";
import PdfContent from "@/views/pages/secure-payment-form/PdfContent.vue";

export default {
  components: {
    PdfContent,
  },
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    messages: {
      type: Array,
      // default: () => [
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "Paragon",
      //     transaction: {
      //       transId: "120059574169",
      //       submitTimeUTC: "2025-03-20T16:38:32Z",
      //       submitTimeLocal: "2025-03-20T09:38:32Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "ZJBM64",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320093831",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 800,
      //       settleAmount: 800,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "47HTR31S5FTA6CDH87RNHZW",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 9,
      //   },
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "KeyBook",
      //     transaction: {
      //       transId: "120059574208",
      //       submitTimeUTC: "2025-03-20T16:39:09Z",
      //       submitTimeLocal: "2025-03-20T09:39:09Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "PUTMRV",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320093909",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 300,
      //       settleAmount: 300,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "P0KY60PEVVVUWMA6IMDGM8A",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 8,
      //   },
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "Tax Research",
      //     transaction: {
      //       transId: "120059574236",
      //       submitTimeUTC: "2025-03-20T16:39:47Z",
      //       submitTimeLocal: "2025-03-20T09:39:47Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "FVVILV",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320093946",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 500,
      //       settleAmount: 500,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "X2M6DIQ1TCYN06IIEWN7GY5",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 5,
      //   },
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "Debt Solution",
      //     transaction: {
      //       transId: "120059574315",
      //       submitTimeUTC: "2025-03-20T16:40:24Z",
      //       submitTimeLocal: "2025-03-20T09:40:24Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "0L8HZL",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320094024",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 90,
      //       settleAmount: 90,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "XEGZ77WXQCC3SK18VQRYESR",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 4,
      //   },
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "Business",
      //     transaction: {
      //       transId: "120059574328",
      //       submitTimeUTC: "2025-03-20T16:41:02Z",
      //       submitTimeLocal: "2025-03-20T09:41:02Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "W41VT6",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Transaction IP Velocity Filter",
      //             action: "report",
      //           },
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320094101",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 500,
      //       settleAmount: 500,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "VLG9ACZ4F2QKK3I2ORB4QT1",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 1,
      //   },
      //   {
      //     status: "success",
      //     message: "paymentSuccess",
      //     program: "Boost Credit",
      //     transaction: {
      //       transId: "120059574366",
      //       submitTimeUTC: "2025-03-20T16:41:40Z",
      //       submitTimeLocal: "2025-03-20T09:41:40Z",
      //       transactionType: "authCaptureTransaction",
      //       transactionStatus: "capturedPendingSettlement",
      //       responseCode: 1,
      //       responseReasonCode: 1,
      //       responseReasonDescription: "Approval",
      //       authCode: "UUBPIZ",
      //       aVSResponse: "Y",
      //       cardCodeResponse: "P",
      //       fDSFilterAction: "authAndHold",
      //       fDSFilters: {
      //         FDSFilter: [
      //           {
      //             name: "Transaction IP Velocity Filter",
      //             action: "report",
      //           },
      //           {
      //             name: "Enhanced AVS Handling Filter",
      //             action: "authAndHold",
      //           },
      //         ],
      //       },
      //       order: {
      //         invoiceNumber: "INV-20250320094139",
      //         discountAmount: 0,
      //         taxIsAfterDiscount: false,
      //       },
      //       authAmount: 59.99,
      //       settleAmount: 59.99,
      //       taxExempt: false,
      //       payment: {
      //         creditCard: {
      //           cardNumber: "XXXX8888",
      //           expirationDate: "XXXX",
      //           cardType: "Visa",
      //         },
      //       },
      //       customer: {
      //         id: "16807",
      //       },
      //       billTo: {
      //         firstName: "Reyna",
      //         lastName: "Aguirre",
      //       },
      //       recurringBilling: false,
      //       customerIP: "200.37.120.98",
      //       product: "Card Not Present",
      //       marketType: "eCommerce",
      //       networkTransId: "IJ56QU9E0NL64SXZK1WAQN1",
      //       authorizationIndicator: "final",
      //     },
      //     concept: "INITIAL PAYMENT",
      //     program_id: 2,
      //   },
      // ],
    },
    paymmentLinks: {
      type: Array,
      // default: () => [
      //   {
      //     id: 5,
      //     amount: 800,
      //     program: "Paragon",
      //     sale_id: 32892,
      //     program_id: 9,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 1,
      //     automatic_payment_date: "2025/04/10",
      //     automatic_payment_amount: 400,
      //     automatic_payment_date_number: 10,
      //     automatic_payment_date_text: "04/10/2025",
      //   },
      //   {
      //     id: 6,
      //     amount: 300,
      //     program: "KeyBook",
      //     sale_id: 32890,
      //     program_id: 8,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 0,
      //     automatic_payment_date: null,
      //     automatic_payment_amount: null,
      //   },
      //   {
      //     id: 7,
      //     amount: 500,
      //     program: "Tax Research",
      //     sale_id: 32888,
      //     program_id: 5,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 1,
      //     automatic_payment_date: "2025/04/20",
      //     automatic_payment_amount: 100,
      //     automatic_payment_date_number: 20,
      //     automatic_payment_date_text: "04/20/2025",
      //   },
      //   {
      //     id: 8,
      //     amount: 90,
      //     program: "Debt Solution",
      //     sale_id: 32887,
      //     program_id: 4,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 1,
      //     automatic_payment_date: null,
      //     automatic_payment_amount: 30,
      //   },
      //   {
      //     id: 9,
      //     amount: 500,
      //     program: "Business",
      //     sale_id: 32885,
      //     program_id: 1,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 0,
      //     automatic_payment_date: null,
      //     automatic_payment_amount: null,
      //   },
      //   {
      //     id: 10,
      //     amount: 59.99,
      //     program: "Boost Credit",
      //     sale_id: 32883,
      //     program_id: 2,
      //     merchant_id: "2",
      //     transaction_id: null,
      //     payment_link_id: 26,
      //     is_automatic_payment: 1,
      //     automatic_payment_date: null,
      //     automatic_payment_amount: 59.99,
      //   },
      // ],
    },
  },
  computed: {
    t() {
      return translations[this.selectedLanguage];
    },
    allSuccess() {
      return this.messages.every((message) => message.status === "success");
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  data() {
    return {
      expandedIndex: null,
      fields: [
        { key: "id", label: "Transaction ID" },
        { key: "timestamp", label: "Fecha/Hora" },
        { key: "program", label: "Programa" },
        { key: "concept", label: "Concepto" },
        { key: "amount", label: "Monto" },
        { key: "status", label: "Estado" },
      ],
    };
  },
  methods: {
    // toggleDetails(index) {
    //   this.expandedIndex = this.expandedIndex === index ? null : index;
    // },
    formatCurrency(amount, symbolPosition = "right") {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });

      const formattedAmount = formatter.format(amount);

      // Detectar la posición del símbolo de moneda en el valor formateado
      const isSymbolFirst = formattedAmount.startsWith(
        formatter.format(0).replace(/\d/g, "")
      );

      if (symbolPosition === "left" && !isSymbolFirst) {
        // Mover el símbolo a la izquierda si no está al principio
        const [value, symbol] = formattedAmount.match(/([^0-9.,]+)|([\d.,]+)/g);
        return `${symbol} ${value}`;
      }

      if (symbolPosition === "right" && isSymbolFirst) {
        // Mover el símbolo a la derecha si está al principio
        const [symbol, value] = formattedAmount.match(/([^0-9.,]+)|([\d.,]+)/g);
        return `${value} ${symbol}`;
      }

      // Devolver el valor formateado directamente si ya está en la posición correcta
      return formattedAmount;
    },
    formatAmericanDateTime(utcDateTime) {
      // Crear un objeto Date a partir de la cadena UTC
      const date = new Date(utcDateTime);

      // Opciones de formato corto
      const options = {
        month: "2-digit", // Mes en dos dígitos (03)
        day: "2-digit", // Día en dos dígitos (18)
        year: "numeric", // Año completo (2025)
        hour: "numeric", // Hora (10)
        minute: "2-digit", // Minutos con dos dígitos (58)
        hour12: true, // Formato de 12 horas (AM/PM)
        timeZone: "America/Los_Angeles", // Zona horaria (PST)
      };

      // Convertir la fecha a formato corto y amigable
      return date.toLocaleString("en-US", options);
    },
    getPaymentDetail(programId) {
      if (!this.paymmentLinks) return {};
      return this.paymmentLinks.find((link) => link.program_id === programId);
    },
    async generatePDF() {
      const pdf = this.$refs.pdfComponent;
      if (!pdf) {
        console.error("pdf component not found");
      }
      pdf.generatePDF();
    },
    close() {
      const element = this.$refs.successLinkContainer;
      element.classList.add("d-none");
    },
  },
};
</script>

<style lang="scss">
.success-link-container {
  .hidden {
    position: absolute;
    left: -9999px;
    visibility: hidden;
  }
  max-width: 90vw;
  margin: 0 auto;
  margin-top: 3rem;
  padding: 1.25rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Montserrat", sans-serif !important;

  .client-program {
    width: 25px !important;
  }
  .mr-05 {
    margin-right: 0.5rem;
  }
  .px-05 {
    padding: 0.5rem;
  }
  .transaction-list {
    display: flex;
    flex-direction: column;
    background-color: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .message-card {
      color: #fff;
      border-radius: 10px;
      margin: 0rem 1rem;
      background-color: #f0f0f0;

      .message-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .transaction-details {
        margin-top: 10px;
        // padding: 10px;
        background: #f0f0f0;
        border-radius: 8px;

        .message-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 4px;
        }
      }

      .text {
        font-size: 0.9rem;
        margin-left: 8px;
        color: #333;
        font-weight: 500;
      }
    }

    /* Animación de aparición/desaparición */
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }
  }
  .text-success {
    color: #28a745;
  }

  .text-danger {
    color: #dc3545;
  }

  /* Title styling with responsive scaling */
  .title {
    margin-top: 2rem;
    font-size: clamp(1.6rem, 5vw, 2.5rem);
    /* Font size dynamically adjusts between 1.6rem and 2.5rem based on screen width */
    font-weight: 700 !important;
    margin-bottom: 1rem;
    color: #0090e7;
  }

  /* Description styling with responsive scaling */
  .description {
    font-size: clamp(1.2rem, 4vw, 1.5rem);
    /* Font size dynamically adjusts between 1.2rem and 1.5rem based on screen width */
    color: #6e6e6e;
    margin-bottom: 2rem;
    font-weight: 700 !important;
  }

  /* Card styling with adjusted padding and max-width */
  .success-card {
    max-width: calc(100% - 40px);
    padding: calc(1.5rem + 1px) 0rem;
  }

  /* Icon container styling */
  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }

  /* Icon styling with scaling on different screens */
  .icon {
    color: #dc3545;
    max-width: 15vw;
    /* Icon scales dynamically on screen size */
  }

  /* Media Queries for responsive adjustments */

  /* Mobile screens */
  @media (max-width: 576px) {
    .title {
      font-size: clamp(1.4rem, 6vw, 2rem);
    }

    .description {
      font-size: clamp(1.1rem, 5vw, 1.4rem);
    }

    .icon {
      max-width: 25vw;
    }
  }

  /* Tablets */
  @media (max-width: 768px) {
    .title {
      font-size: clamp(1.5rem, 5vw, 2.2rem);
    }

    .description {
      font-size: clamp(1.15rem, 4.5vw, 1.45rem);
    }

    .icon {
      max-width: 20vw;
    }
  }

  /* Laptops & Small desktops */
  @media (max-width: 1024px) {
    .title {
      font-size: clamp(1.6rem, 4.5vw, 2.4rem);
    }

    .description {
      font-size: clamp(1.2rem, 4vw, 1.5rem);
    }

    .icon {
      max-width: 18vw;
    }
  }

  /* Large desktops */
  @media (min-width: 1200px) {
    .title {
      font-size: clamp(1.6rem, 3vw, 2.5rem);
    }

    .description {
      font-size: clamp(1.2rem, 3vw, 1.6rem);
    }

    .icon {
      max-width: 15vw;
    }
  }
}

.dark-layout {
  .success-link-container {
    .title {
      color: #0090e7;
    }

    .transaction-list {
      background-color: #17171a;

      .message-card {
        background-color: #333;
        color: #fff;
      }

      .transaction-details {
        background: #333;

        .message-row {
          color: #ccc;
        }
      }
      .text {
        color: #fff;
      }
    }

    .label {
      color: #ccc;
    }

    .value {
      color: #fff;
    }
  }
}
</style>
